// File: services/recipe.js
import { toast } from "react-toastify";
const url = `${process.env.REACT_APP_BASEURL}/api/admin/resources`;

export const GetResourceListApi = async () => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ data: JSON.stringify({ action: "get" }) }),
    });

    if (!response.ok) throw new Error("Failed to fetch resource list.");
    return await response.json();
  } catch (error) {
    console.error("Fetch error:", error);
  }
};

export const handleDeleteResource = async (recipeId, refreshCallback) => {
  if (window.confirm("Are you sure you want to delete this Resource?")) {
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ data: JSON.stringify({ action: "delete", _id: recipeId }) }),
      });

      const data = await response.json();
      if (data.success) toast.success("Resource deleted successfully");
      else toast.warning("Resource deleted, but response was unexpected");
      refreshCallback();
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Something went wrong while deleting.");
    }
  }
};

export const submitResourceApi = async (resourceData) => { 
  try {
    const formData = new FormData();
    formData.append("data", JSON.stringify({
      action: resourceData._id ? "edit" : "add",
      _id: resourceData._id,
      title: resourceData.title,
      url: resourceData.url,
      content: resourceData.content
    }));

    if (resourceData.imageFile) {
      formData.append("image", resourceData.imageFile);
    }

    const response = await fetch(url, { method: "POST", body: formData });
    const result = await response.json();

    if (result.success || response.status === 201) {
      toast.success(resourceData._id ? "Resource updated successfully" : "Resource added successfully");
      return result;
    } else {
      toast.error(result.message || "Failed to save Resource");
      return null;
    }
  } catch (error) {
    console.error("Submit error:", error);
    toast.error("Something went wrong while saving the Resource");
    return null;
  }
};

export const getResourceByIdApi = async (id) => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ data: JSON.stringify({ action: "getById", _id: id }) }),
    });

    const result = await response.json();
    if (result.success) return result;
    else toast.error("Failed to load Resource");
  } catch (err) {
    console.error("Fetch by ID error:", err);
  }
};
